/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Rails_Deals_TitleInputs */

const en_directory_rails_deals_title = /** @type {(inputs: Directory_Rails_Deals_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Discount Codes`)
};

const zh_directory_rails_deals_title = /** @type {(inputs: Directory_Rails_Deals_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`折扣码`)
};

/**
* | output |
* | --- |
* | "Discount Codes" |
*
* @param {Directory_Rails_Deals_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_rails_deals_title = /** @type {((inputs?: Directory_Rails_Deals_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Rails_Deals_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_rails_deals_title(inputs)
	return zh_directory_rails_deals_title(inputs)
});
export { directory_rails_deals_title as "directory.rails.deals_title" }